import { ElementRef, Injectable, QueryList } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ActivecarouselService {
  syncActiveCarouselArrowAndSlider(
    event: Event,
    carouselind: QueryList<ElementRef>,
    carouselitems: QueryList<ElementRef>
  ): void {
    event.preventDefault();
    for (let i = 0; i < carouselind.toArray().length; i++) {
      // Clears the active class for indicator
      if (carouselind.toArray()[i].nativeElement.classList.contains('active')) {
        carouselind.toArray()[i].nativeElement.classList.remove('active');
      }
      // Adds the active class based on active carousel
      if (
        carouselitems.toArray()[i].nativeElement.classList.contains('active')
      ) {
        carouselind.toArray()[i].nativeElement.classList.add('active');
      }
    }
    event.stopPropagation();
  }
}
